import {Injectable, OnInit} from '@angular/core';
import {Constant} from "../constant";
import {NgForm} from "@angular/forms";
import { ConvertDataService } from './convertData.service';
import { DataService } from './data.service';
import { Product } from '../models/product.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AppQueries } from 'src/app/state';

@Injectable({ providedIn: 'root' })

export class ProductService {
  resource: any = {};
  products: any[] = [];
  constructor(
    private http: HttpClient,
    private dataService: DataService,
    public appQueries: AppQueries,
  ) {
    this.resource = this.dataService.getFull();
    dataService.subData()
    .then((res) => {  
      this.resource = res;
    });
    this.appQueries.products$
    .subscribe((products) => {
      this.products = products.map((item) => {
        return {
          id: item.id,
          name: item.shortName,
          orderName:  !item.subCode ? item.shortName : item.shortName + '/' + item.subCode,
          code: item.code,
        }
      }).sort((item1, item2) => {
        if (item1.code.toUpperCase() > item2.code.toUpperCase()) {
          return 1;
        } else if (item1.code.toUpperCase() < item2.code.toUpperCase()) {
          return -1;
        }
        return 0;
      })
    });
  }
  getList() {
    return this.products;
  }
  isResource() {
    return this.resource ? true : false;
  }
  checkChange(itemNew , itemOld) {
    let change = false;
    for (let property in itemNew) {
      if (change) {
        return true;
      }
      if (typeof itemNew[property] === 'object' && itemNew && itemOld) {
        change = this.checkChange(itemNew[property], itemOld[property])
      } else if (itemNew && itemOld){
        if ((itemNew[property] || itemOld[property])) {
          if ( (typeof itemNew[property] === 'number' || typeof itemOld[property] === 'number')) {
            change = ConvertDataService.revertMoneytoNumber(itemNew[property]) != ConvertDataService.revertMoneytoNumber(itemOld[property]);
          } else if (itemNew[property] !== itemOld[property]) {
            change = true;
          }
        }
      }
    }
    if (change) {
    }
    return change;
  }
  parse(product: Product) { 
    if (!product) {
      return {};
    }
    product.owner = this.setSanitize(product.owner);
    product.owner = product.owner || {};
    if (product.productBond && product.productBond.issuerInfo
      && product.productBond.issuerInfo.id) {
        product.owner = product.productBond.issuerInfo;
    }
    product.priceMoney = ConvertDataService.parseMoney(product.price || product.issuePrice);
    let assets = '';
    product.productAssetAllocationList = product.productAssetAllocationList || [{ name: '-' }];
    product.productAssetAllocationList = product.productAssetAllocationList.map((assetId) => {
      const asset = {
        id: assetId,
        name: ''
      }
      this.resource.assetAllocations.forEach((assetAllocation) => {
          if (asset.id === assetAllocation.id) {
          asset.name = assetAllocation.name;
          assets+= asset.name + ', ';
        }
      })
      return asset;
    })
    
    if (!product.agents || (product.agents && product.agents.length === 0)) {
      product.agents =  [{
        id: '',
        branch: ''
      }]
    }
    product.assets = assets.substring(0, assets.length -2);
    product.productAssetAllocationModelList = product.productAssetAllocationModelList|| [];
    product.assetNames = product.productAssetAllocationModelList.map(ass => ass.name).join(", ");
    product.productFeeDiscountList = product.productFeeDiscountList || [];
    product.productFeeList = product.productFeeList || [];
    product.productFeeList.sort((a, b) => {
      if (a.beginVolume > b.beginVolume) {
          return 1;
      }
      if (a.beginVolume < b.beginVolume) {
          return -1;
      }
          return 0; 
    })
    product.feeBuys = [];
    product.normalTimeHolds = [];
    product.productFeeList.forEach((fee) => {
      if (fee.type === 'BUY') {
        product.feeBuys.push(fee);
      } else if (fee.type === 'SELL')  {
        product.normalTimeHolds.push(fee);
      }
    })

    if (product.website && product.website.substring(0, 4) !== 'http') {
      product.website = 'http://' + product.website;
    }
    if (product.bank || product.productSupervisoryBankAccount) {
      !product.bank && (product.bank = product.productSupervisoryBankAccount || {});
      this.resource.banks.forEach((bank) => {
          if (bank.id === product.bank.bankId) {
              product.bank.bankName = bank.shortName;
          }
      })
    } else {
      product.bank = {};
    }
    if (product.productTransactionDateList) {
      if (Constant.arraysEqual(Constant.DAYS_OF_WEEK_WORKING_DAY, product.productTransactionDateList)) {
        product.transactionDate = 'Thứ Hai đến Thứ Sáu';
      } else if (product.productTransactionDateList.length > 0) {
        product.transactionDate = this.dataService.daysOfWeek
          .filter(day => product.productTransactionDateList.indexOf(day.id) > -1)
          .map(day => day.name)
          .join(', ');
      } else {
        product.transactionDate = '';
      }
    }
    if (product.productBond) {
      product.bondTerm = this.calculateBondTerm(product.maturityAt, product.endIssueAt)
      if (product.productBond && product.productBond.yieldBankId) {
        this.resource.banks.forEach((bank) => {
           if (product.productBond.yieldBankId === bank.id) {
            product.productBond.bank = bank.shortName;
              product.productBond.yieldBankBranchTmp = product.productBond.yieldBankBranch.name;
           }
        })
      }
      this.resource.paymentPeriodTypes.forEach((paymentPeriodType) => {
        if (paymentPeriodType.id === product.productBond.paymentPeriodId) {
          product.productBond.paymentPeriod = paymentPeriodType.name;
          product.productBond.paymentPeriodValue = paymentPeriodType.value;
        }
      })
      if (product.productBond.paymentPeriod &&  product.productBond.paymentPeriod.name) {
        product.productBond.paymentPeriod = product.productBond.paymentPeriod.name;
        product.productBond.paymentPeriodValue = product.productBond.paymentPeriod.value;
      }
    } else {
      if (product.type === Constant.CODE_FIXED_BOND ||
        product.type === Constant.CODE_FLEXIBLE_BOND) {
          product.productBond = {};
        }
    }
    product = this.setFloatRate(product);
    return product;
  }
  setFloatRate(product) {
    if (product && product.productBond && product.productBond.interestPaymentTimelineModels
    && !product.productBond.floatRate) {
        let floatRate = [], fixRate = [];
        let positionFixed = -1, positionFloat = -1;
        product.productBond.interestPaymentTimelineModels.forEach((timeline, index) => {
          if (!timeline.isFloatingPeriod) {
            positionFixed = index;
          } else positionFloat = index;
        })
        if (positionFixed > -1) {
          product.productBond.fixRateDate = true;
        }
        if (positionFloat > -1) {
          product.productBond.floatRateDate = true;
        }
        if (positionFixed > -1 && positionFloat > -1) {
          let timeline = product.productBond.interestPaymentTimelineModels[positionFixed];
          product.productBond.stringDate = 'Bắt đầu từ ' + ConvertDataService.parseDate( timeline.notReceivedInterestSince);
        } 
        if (floatRate.length > 0) {
          product.isFloat = true;
        }
    }
    return product;
  }
  calculateBondTerm(maturityDate, endDate, noMonth?, noAdjust?) {
    if (typeof maturityDate !== 'number' && typeof endDate !== 'number') {
      return;
    }
    let bondTerm: any ='';
    let date = new Date();
    date = new Date((date.getMonth()+1)+'/'+date.getDate()+'/'+date.getFullYear());
    let numberDate = ((((maturityDate - date.getTime()) / 1000) / 60) / 60) / 24;
    if (!noAdjust) {
      bondTerm = ConvertDataService.decimalAdjust('round', numberDate/30.42 , -1);
      if (!noMonth) {
        bondTerm += ' tháng ';
      }
      return bondTerm;
    } else {
      bondTerm = ConvertDataService.decimalAdjust('round', numberDate/30.42, -2);
      return bondTerm;
    }
  }
  
  setSanitize(owner) {
    owner.userSocials = owner.userSocials || [];
    owner.userSocials = owner.userSocials.map((item) => {
      if (!item.socialTypeInfo)  {
        item.socialTypeInfo = {
          code: ''
        };
      }
      if (item.socialTypeInfo.code  === Constant.FACEBOOK || item.socialTypeInfo.code  === Constant.KAKAOTALK
        || item.socialTypeInfo.code  === Constant.YOUTUBE || item.socialTypeInfo.code  === Constant.TWITTER) {
        item.sanitize =  item.name;
      } else if (item.socialTypeInfo.code === Constant.MESSENGER) {
          item.sanitize = item.name.indexOf('http://') > 0 ? item.name : 'https://' + item.name;
        } else if (item.socialTypeInfo.code  === Constant.SKYPE) { 
          item.sanitize = ('skype:' + item.name + '?chat')
        } else if (item.socialTypeInfo.code  === Constant.VIBER) {
          item.sanitize = ('viber://contact?number=' + item.name)
        } else if (item.socialTypeInfo.code  === Constant.ZALO) {
          item.sanitize = 'https://zalo.me/' + item.name;
        } else if (item.socialTypeInfo.code  === Constant.WECHAT) {
          item.sanitize = 'weixin://dl/profile=' + item.name;
        } else if (item.socialTypeInfo.code  === Constant.WHATSAPP) {
          item.sanitize = 'https://wa.me/' + item.name;
        } else { 
          item.sanitize = (item.socialTypeInfo.code.toLowerCase() + '://send?phone=' + this.getName(item.name))
        }
      return item;
    })
    return owner;
  }
  
  getName(name) {
    if (Constant.checkAndroid()) {
      return  name.substring(1,name.length)
    } else return name
  }
  getTypes(type) {
    let types;
    switch (type) {
      case Constant.CODE_ORDER_FUND: 
        types = [ 
          Constant.CODE_NEW_FUND,
          Constant.CODE_TRADING_FUND,
        ]
      break;
      case Constant.CODE_ORDER_BOND: 
        types = [ 
          Constant.CODE_FIXED_BOND,
          Constant.CODE_FLEXIBLE_BOND,
          Constant.CODE_MATURITY_BOND
        ]
      break;
      case Constant.CODE_ORDER_CD: 
        types = [ 
          Constant.CODE_FIXED_INTEREST_ON_FIXED_CD,
          Constant.CODE_FLEXIBLE_CD,
          Constant.CODE_FLEXIBLE_INTEREST_ON_FIXED_CD,
        ]
      break;
      case Constant.CODE_FUND: 
        types = [ 
          Constant.CODE_NEW_FUND,
          Constant.CODE_TRADING_FUND,
        ]
      break;
      case Constant.CODE_BOND: 
        types = [ 
          Constant.CODE_FIXED_BOND,
          Constant.CODE_FLEXIBLE_BOND,
          Constant.CODE_MATURITY_BOND
        ]
      break;
      case Constant.CODE_CD: 
        types = [ 
          Constant.CODE_FIXED_INTEREST_ON_FIXED_CD,
          Constant.CODE_FLEXIBLE_CD,
          Constant.CODE_FLEXIBLE_INTEREST_ON_FIXED_CD,
        ]
      break;
    }
    return types;
  }
}
